import { RegistrationApi } from '../../api';
import axios from '../axios';

const registrationApi = new RegistrationApi(undefined, undefined, axios);

export default registrationApi;
